import Head from 'next/head';
import React, { useEffect } from 'react';
import { CookiesPolicy } from '../../components';
import { withLayout } from '../../Layout/Layout';

export const CookiesPolicyHOC = ({ setCookieAccepted }) => {
  useEffect(() => {
    setTimeout(() => {
      setCookieAccepted({
        accepted: false,
        opened: false,
      });
    }, 0);

  }, [setCookieAccepted]);
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/cookies_policy`} />
      </Head>
      <CookiesPolicy />
    </>
  );
};
export default withLayout(CookiesPolicyHOC, true);
